export const TERMS = "https://www.superplay.co/terms/";

export const getDeepLink = (gameData?: { deep_link?: string }): string => {
  return gameData?.deep_link || "itms-apps://itunes.apple.com";
};

export const getFallbackUrl = (gameData?: {
  fallback_url?: string;
}): string => {
  return gameData?.fallback_url || "https://chatgpt.com";
};
